import { render, staticRenderFns } from "./ThreadHeading.vue?vue&type=template&id=3e7cfaa4&scoped=true&"
import script from "./ThreadHeading.vue?vue&type=script&lang=js&"
export * from "./ThreadHeading.vue?vue&type=script&lang=js&"
import style0 from "./ThreadHeading.vue?vue&type=style&index=0&id=3e7cfaa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7cfaa4",
  null
  
)

export default component.exports